export default "https://cdn-static-staging.gokick.com/assets/fcb4ac80126f26ea915890c2472f26527471791c/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";